import "~/misc/common";
import { p } from "~/misc/common";
import L from "~/misc/2d/leaflet";
import { Context2d } from "~/types/map";

export function initNature(map: Context2d) {
  p('initNature');

  map.tree.create_node('#', {
    id: 'nature',
    icon: 'fa fa-leaf',
    text: "Természet",
    state: {
      checked: false
    }
  });
  map.tree.create_node('nature', {
    id: 'nature_simple',
    icon: 'bi-shield',
    text: "Védett"
  });
  map.tree.create_node('nature', {
    id: 'nature_2000',
    icon: 'bi-globe-europe-africa',
    text: "Natura2000"
  });
  map.tree.create_node('nature', {
    id: 'nature_forest',
    icon: 'fa fa-tree',
    text: "Erdőtérkép"
  });

  const fgSimple = L.tileLayer.wms('https://webgis.okir.hu/geoserver/tirweb/wms?', {
    layers: 'nptkttte',
    format: 'image/png',
    transparent: true,
    version: '1.3.0',
    crs: L.CRS.EPSG3857,
    opacity: 0.7
  });
  const fg2000 = L.tileLayer.wms('https://webgis.okir.hu/geoserver/tirweb/wms?', {
    layers: 'natura2000_sac_2017',
    format: 'image/png',
    transparent: true,
    version: '1.3.0',
    crs: L.CRS.EPSG3857,
    opacity: 0.7
  });
  const fgForest = L.tileLayer.wms("https://erdoterkep.nebih.gov.hu/geoserver/nebih/wms?", {
    layers: "KUL_RESZLET_VW",         // required
    styles: "vedettseg",              // style defined on server
    format: "image/png",              // request PNG tiles
    transparent: true,                // make background transparent
    version: "1.1.1",                 // WMS version
    crs: L.CRS.EPSG3857,              // projection
  });

  map.tree.element.on("check_node.jstree uncheck_node.jstree state_ready.jstree", refreshLayers);
  function refreshLayers() {
    fgSimple.remove();
    fg2000.remove();
    fgForest.remove();
    map.tree.is_checked('nature_simple') ? fgSimple.addTo(map) : null;
    map.tree.is_checked('nature_2000') ? fg2000.addTo(map) : null;
    map.tree.is_checked('nature_forest') ? fgForest.addTo(map) : null;
  }

  //'Utak': L.tileLayer(`https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=${API_KEY2}`, {
  //	//tileSize: 512,
  //	//zoomOffset: -1,
  //	maxZoom: 20,
  //	opacity: 1, // optional, adjust for readability
  //	attribution: '© MapTiler, OpenStreetMap contributors'
  //})

  //initSpecies(map);

}
